<h4 nz-typography>Icons</h4>
<i nz-icon nzType="fa:chevron-down"></i>
<i nz-icon nzType="fa:chevron-up"></i>
<i nz-icon nzType="fa:chevron-right"></i>
<i nz-icon nzType="fa:chevron-left"></i>
